export enum InstitutionTypes {
	Academy = "Academy",
	ChildrensCentre = "Childrens Centre",
	College = "College",
	Independent = "Independent",
	LEA = "LEA",
	University = "University",
}
